import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useAuth0 } from '@auth0/auth0-react';
import LoginRequiredPage from './components/LoginRequiredPage';
import Loader from './Loader';

const hasAuth0CallbackParams = () => {
  const search = window.location.search || '';
  return /(^|[?&])code=/.test(search) && /(^|[?&])state=/.test(search);
};

function requireAuthentication(Component) {
  const Auth0AuthenticatedComponent = (props) => {
    const {
      isLoading: isAuth0Loading,
      isAuthenticated: isAuth0Authenticated,
    } = useAuth0();

    if (isAuth0Loading || hasAuth0CallbackParams()) {
      return <Loader />;
    }

    if (!props.isAuthenticated && isAuth0Authenticated) {
      return <Loader />;
    }

    if (!props.isAuthenticated) {
      return <LoginRequiredPage />;
    }

    return <Component {...props} />;
  };

  Auth0AuthenticatedComponent.propTypes = {
    isAuthenticated: PropTypes.bool.isRequired,
  };

  const AuthenticatedComponent = props => {
    if (props.redirect) {
      window.location.href = props.clientCenterHost.replace(/"/g, "'");
      return true;
    }

    if (props.auth0Enabled) {
      return <Auth0AuthenticatedComponent {...props} />;
    }

    if (!props.isAuthenticated) {
      return <LoginRequiredPage />;
    }
    
    return <Component {...props} />;
  };

  AuthenticatedComponent.propTypes = {
    isAuthenticated: PropTypes.bool.isRequired,
    redirect: PropTypes.bool.isRequired,
    clientCenterHost: PropTypes.string,
    clientId: PropTypes.string,
    auth0Enabled: PropTypes.bool.isRequired,
  };

  function mapStateToProps(state) {
    const configuration = state.configuration || {};

    return {
      redirect: false, // never rediect
      clientCenterHost: configuration.clientCenterHost,
      isAuthenticated: state.authentication.isAuthenticated || false,
      auth0Enabled: !!(configuration.auth0Domain && configuration.auth0ClientId),
    };
  }

  return connect(mapStateToProps)(AuthenticatedComponent);
}

export default requireAuthentication;
